export default {
    init() {
        if(window.profile_photo_handle === null) {
            // A previously set avatar is no longer approved
            localStorage.removeItem('profile_photo_handle');
        } else {
            // We are on the dashboard and are receiving an approved avatar
            if(typeof window.profile_photo_handle === 'string') {
                localStorage.setItem('profile_photo_handle', window.profile_photo_handle);
                var handle = window.profile_photo_handle;
            } else {
                var handle = localStorage.getItem('profile_photo_handle');
            }
            // Continuing on
            if(handle !== null) {
                let div = $('#dashboard-avatar');
                if(div.length > 0) {
                    const url = 'https://cdn.filestackcontent.com/resize=height:72,width:72,fit:crop/'+handle;
                    div.html(`<img src="${url}" class="rounded-xs" alt="Your Avatar">`)
                }
            }
        }  
    }
};